import $ from '@modules/jquery-import';

$.fn.toggleMenu = function ( opt ) {
    var conf = $.extend( {
        TOGGLE_ITEM_SELECTOR: 'data-belongs-to',
        ACTIVE_CLASS: 'selected',
        MENU_ITEM_CLASS: 'menu-item',
        closeOpenMenus: true
    }, opt );

    return $( this ).each( function () {

        var selected_menu_item = null,
            $menu = $( this ),
            $toggleItems = $menu.find( '[' + conf.TOGGLE_ITEM_SELECTOR + ']' );

        //hide togglable items by default
        $toggleItems.hide();

        $menu.click( function ( e ) {
            var target = e.target;

            if ( $( target ).hasClass( conf.MENU_ITEM_CLASS ) ) {
                e.preventDefault();
                if ( conf.closeOpenMenus && target !== selected_menu_item ) {
                    $toggleItems.slideUp();
                }

                //toggle selected item class
                $menu.find( '.' + conf.MENU_ITEM_CLASS ).removeClass( conf.ACTIVE_CLASS );
                $( target ).addClass( conf.ACTIVE_CLASS );

                //display target item
                $menu.find( '[' + conf.TOGGLE_ITEM_SELECTOR + '="' + target.id + '"]' ).slideToggle( 200 );
                selected_menu_item = target;
            }
        } );
    } );
};
